import * as Actions from 'actions/types';
import { ViewStatus, AppViews } from 'resources/enums';

export function updateApp(data) {
    return {
        type: Actions.UPDATE_APP,
        app: data
    }
}

